import React, { useState, useEffect } from "react";

const STATURI_MEMBRU = [
  { value: "activ", label: "Activ" },
  { value: "inactiv", label: "Inactiv" },
  { value: "suspendat", label: "Suspendat" },
];

export default function ModificareStatusMembru() {
  const [membri, setMembri] = useState([]);
  const [selectedMembru, setSelectedMembru] = useState("");
  const [statusMembru, setStatusMembru] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    async function fetchMembri() {
      try {
        const res = await fetch("https://prdp-api.suport-949.workers.dev/api/membri", {
          headers: {
            Authorization: "Bearer unwantedtok",
          },
        });
        if (!res.ok) throw new Error("Eroare la încărcarea membrilor");
        const data = await res.json();
        setMembri(data);
      } catch (err) {
        setError(err.message);
      }
    }
    fetchMembri();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSuccessMsg("");
    if (!selectedMembru) {
      setError("Alege un membru");
      return;
    }
    if (!statusMembru) {
      setError("Selectează un status");
      return;
    }

    setLoading(true);
    try {
      const m = membri.find((mb) => mb.id === selectedMembru);
      if (!m) {
        setError("Membru inexistent"); setLoading(false); return;
      }
      // Construiește payload strict cu cheile din schema SQL!
      const payload = {
        id: m.id,
        nume: m.nume,
        prenume: m.prenume,
        adresa: m.adresa,
        oras: m.oras,
        judet: m.judet,
        tara: m.tara,
        email: m.email,
        telefon: m.telefon,
        cnp: m.cnp,
        serie_numar_ci: m.serie_numar_ci,
        tip_cotizatie: m.tip_cotizatie,
        data_start: m.data_start,
        data_sfarsit: m.data_sfarsit,
        status_membru: statusMembru,
        user_id_supabase: m.user_id_supabase || "",
        puncte: typeof m.puncte === "number" ? m.puncte : 0,
        timestamp_creare: m.timestamp_creare || "",
      };

      // Șterge orice apariție accidentală a statusmembru (fără underscore)
      if ('statusmembru' in payload) delete payload.statusmembru;

      const res = await fetch(`https://prdp-api.suport-949.workers.dev/api/membri/${selectedMembru}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer unwantedtok",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Eroare la modificarea statusului membru");
      }

      setSuccessMsg("Statusul membrului a fost modificat cu succes!");
      setSelectedMembru("");
      setStatusMembru("");
      // Reîncarcă membrii
      const resMembers = await fetch("https://prdp-api.suport-949.workers.dev/api/membri", {
        headers: { Authorization: "Bearer unwantedtok" }
      });
      setMembri(await resMembers.json());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <h3>Modificare status membru</h3>
      {error && <div className="alert alert-danger">{error}</div>}
      {successMsg && <div className="alert alert-success">{successMsg}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Membru:</label>
          <select className="form-select" value={selectedMembru}
            onChange={(e) => setSelectedMembru(e.target.value)} required>
            <option value="">-- Alege membru --</option>
            {membri.map((m) =>
              <option key={m.id} value={m.id}>{m.prenume} {m.nume}</option>
            )}
          </select>
        </div>
        <div className="mb-3">
          <label>Status:</label>
          <select className="form-select" value={statusMembru}
            onChange={(e) => setStatusMembru(e.target.value)} required>
            <option value="">-- Alege status --</option>
            {STATURI_MEMBRU.map(({ value, label }) =>
              <option key={value} value={value}>{label}</option>
            )}
          </select>
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Se salvează..." : "Modifică statusul"}
        </button>
      </form>
    </div>
  );
}
